import { useQuery } from '@tanstack/react-query';
import { ediphorDiagnosticsService } from '@/services/api/ediphorDiagnosticsService';
import { TokenStatus } from '../TokenStatus';
import { PollingMonitor } from '../PollingMonitor';
import { HelpSection } from '../HelpSection';

interface DashboardTabProps {
  onNavigateToTab: (tab: 'custom' | 'pipeline') => void;
}

export function DashboardTab({ onNavigateToTab }: DashboardTabProps) {
  // Query for token info (refreshes every 10s)
  const { data: tokenInfo, refetch: refetchTokenInfo } = useQuery({
    queryKey: ['ediphor-token-info'],
    queryFn: () => ediphorDiagnosticsService.getTokenInfo(),
    refetchInterval: 10000,
    retry: 1
  });

  // Query for polling history (always refreshes every 5s to show real-time results)
  const { data: pollingHistory } = useQuery({
    queryKey: ['ediphor-polling-history'],
    queryFn: () => ediphorDiagnosticsService.getPollingHistory(),
    refetchInterval: 5000,
    retry: 1
  });

  return (
    <div className="space-y-6">
      {/* Status Grid - Equal Width on Desktop */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Token Status */}
        <div>
          <TokenStatus tokenInfo={tokenInfo} onRefresh={refetchTokenInfo} />
        </div>

        {/* Polling Monitor */}
        <div>
          <PollingMonitor pollingHistory={pollingHistory} />
        </div>
      </div>

      {/* Help Section */}
      <HelpSection onNavigateToTab={onNavigateToTab} />
    </div>
  );
}
